<script setup lang="ts">
import type {HTMLAttributes} from "vue"
import {cn} from "@/lib/utils"

interface SkeletonProps {
  class?: HTMLAttributes["class"]
}

const props = defineProps<SkeletonProps>()
</script>

<template>
  <div
      data-slot="skeleton"
      :class="cn('animate-pulse rounded-md bg-neutral-200 dark:bg-neutral-800', props.class)"
  />
</template>
